module.exports = "/_next/static/resources/art-a87677e4b9e3f0e376c5e7324dc74ef2.jpg";